import { render, staticRenderFns } from "./AccelerometerReadings.vue?vue&type=template&id=2cd62e83&"
import script from "./AccelerometerReadings.vue?vue&type=script&lang=js&"
export * from "./AccelerometerReadings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports